import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @devextreme
import { Popover } from 'devextreme-react/popover';
// utils
import { timezones } from '../../../utils/format';
// styles
import { MoreButton } from '../../../styles';

// ----------------------------------------------------------------------

interface Props {
  row: {
    iotDeviceId: string;
    iotGroupId: string;
    iotGroupName: string;
    location: string;
    serialNumber: string;
    number: number;
    powerType: string;
    enabled: boolean;
    waterQualitySensorCount: number;
    createdAt: string;
  };
  setSetting: any;
  setDialog: React.Dispatch<any>;
};

// ----------------------------------------------------------------------

export default function TableRow({ row, setSetting, setDialog }: Props){
  const navigate  = useNavigate();

  const date = timezones(row.createdAt, 'YYYY-MM-DD HH:mm:ss');

  const [ visible, setVisible ] = useState(false);
  
  return (
    <tr>
      <td>{ row.iotGroupName }</td>
      <td>{ row.location }</td>
      <td>{ row.serialNumber }</td>
      <td>{ row.number }</td>
      <td>{ row.powerType }</td>
      <td>{ row.enabled ? '사용' : '사용 안 함' }</td>
      <td>
        <button type='button' onClick={() => navigate('sensors', {state: { answer: row }})}>{row.waterQualitySensorCount}</button>
      </td>
      <td>{ date }</td>
      <td>
        <MoreButton id={`more${row.iotDeviceId}`} className='more' onClick={() => setVisible(true)} />
        <Popover
          target={`#more${row.iotDeviceId}`}
          visible={visible}
          hideOnOutsideClick={true}
          onHiding={() => setVisible(false)}
          position='left'
        >

          <button
            onClick={() => {
              setVisible(false);
              setSetting(row);
            }}
          >
            장비 설정
          </button>

          <button
            onClick={() => {
              setVisible(false);
              setDialog(row.iotDeviceId);
            }}
          >
            장비 삭제
          </button>

          <button onClick={() => navigate('sensors', {state: { answer: row }})}>
            수질 센서
          </button>

          <button onClick={() => navigate('predictions', {state: { values: row }})}>
            수질 예측
          </button>
        </Popover>
      </td>
    </tr>
  );
}